import {NgModule} from '@angular/core';
import {CommonModule, HashLocationStrategy, LocationStrategy, DatePipe, PathLocationStrategy} from '@angular/common';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {HttpClient, HTTP_INTERCEPTORS} from '@angular/common/http';
import {LoadingBarHttpClientModule} from "@ngx-loading-bar/http-client";
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {DxDataGridModule} from 'devextreme-angular';

import {AppRoutingModule} from './app.routes';
import {App} from "./app.component";
import {AppService} from './app.service';
import {Config} from './app.config';

import {MensajeModule} from '@mensaje/Mensaje.module';

import {SeguridadService} from "@servicios/Seguridad.service";
import {SistemaService} from "@servicios/Sistema.Service";
import {UsuarioService} from '@servicios/Usuario.service';
import { ComponentesModule } from '@componentes/Componentes.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PipesModule } from '@pipes/Pipes.module';
import { GlobalModule } from '@contenido/AppContent/global/global.module';
//import {AuthInterceptor} from '@servicios/Interceptor.service';


@NgModule(
    {
        bootstrap: [App],
        declarations:
            [
                App
            ],
        imports:
            [
                BrowserAnimationsModule,
                AppRoutingModule,
                ComponentesModule,
                LoadingBarHttpClientModule,
                MensajeModule,
                MatTooltipModule,
                PipesModule,
                GlobalModule,
                CommonModule,
                DxDataGridModule,
                TranslateModule.forRoot(
                    {
                        loader:
                        {
                            provide: TranslateLoader,
                            useFactory: HttpTranslateLoader,
                            deps: [HttpClient]
                        }
                    }
                )
            ],
        exports:
            [
                TranslateModule
            ],
        providers:
            [
                SeguridadService,
                SistemaService,
                UsuarioService,
                AppService,
                Config,
                DatePipe,
                {provide: LocationStrategy, useClass: PathLocationStrategy}
                //{provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true}
            ]
    })

export class AppModule {
    constructor() {
    }

}

export function HttpTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, "./assets/i18n/");
}

